import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import alertUtil from './alertUtil';
import classList from '../../common/utils/classList';
import Alert, { AlertAttrs } from '../../common/components/Alert';
import CommentPost from '../components/CommentPost';
import PicturePreviewModal from '../dianLiang/PicturePreviewModal';
function isIOSDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
export default class CommentModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.id = vnode.attrs.id;
    this.count = vnode.attrs.count;
    this.include =
      'replyToUser,replyToUser.user,replyToPost,replyToPost.user,user,user.groups,editedUser,hiddenUser,discussion,discussion.user,discussion.user.userLevel,discussion.user.userLevel.levelConf,user.userLevel,user.userLevel.levelConf,likes,';
    if (app.initializers.has('fof-gamification')) {
      this.include += 'user.ranks,upvotes,';
    }
    if (app.initializers.has('fof/reactions')) {
      this.include += 'reactions';
    }
    this.isAtBottom = false; // 初始化标志，用于标记是否滚动到底部
    this.scrollContainer = null; // 用于存储滚动容器的引用
    this.offset = 0;
    this.limit = 20;
  }

  oncreate(vnode) {
    super.oncreate(vnode)
    // 绑定滚动事件监听器
    setTimeout(() => {
      this.setScrollListener(vnode);
      m.redraw(); // 在DOM操作后重绘
    });
  }
  onremove(vnode) {
    // 当组件卸载时，移除事件监听器
    this.removeScrollListener();
  }
  setScrollListener(vnode) {
    // 获取滚动容器并绑定滚动事件
    this.scrollContainer = vnode.dom.querySelector('.scroll-box');
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.checkScrollBottom.bind(this));
      this.checkScrollBottom(); // 初始检查是否已在底部
    } else {
      console.error('Scrollable container not found.');
    }
  }
  removeScrollListener() {
    // 解绑滚动事件
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.checkScrollBottom.bind(this));
    }
  }
  checkScrollBottom() {
    // 检查是否滚动到了底部
    const container = this.scrollContainer;
    const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
    if (isAtBottom && !this.isAtBottom) {
      this.isAtBottom = true;
      if (this.count > this.limit) {
        this.loadMoreComments();
      }
    } else if (!isAtBottom && this.isAtBottom) {
      this.isAtBottom = false;
    }
  }
  loadMoreComments() {
    app.store
      .find('trees', this.id, { include: this.include.replace(/,\s*$/, ''), page: { offset: this.offset, limit: this.limit } })
      .then((response) => {
        delete response.payload;
        [].push.apply(app.cache.trees[this.id], response);
        this.offset += 20;
        this.limit += 20;
        m.redraw();
      });
  }

  view() {
    if (this.alertAttrs) {
      this.alertAttrs.dismissible = false;
    }

    return (
      <div className={classList('Modal modal-dialog fade Modal-comment-container', this.className())}>
        <div className="Modal-comment-content">{this.content()}</div>
      </div>
    );
  }

  content() {
    return (
      <div className="Modal-comment-body">
        <div className="header">
          <Button
            className="delete-icon"
            onclick={() => {
              app.modal.close();
            }}
          >
            <img className="icon-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btn-guanbilan.png`}></img>
          </Button>
        </div>
        <div className="count">{app.translator.trans('dl-tree.forum.all_responses', { count: this.count })}</div>
        <div className="scroll-box scrollable-content">
          <div className="CommentTree CommentTree-lin" id={this.id}>
            {app.cache.trees[this.id]
              .filter((thing, index, self) => self.findIndex((t) => t.id() === thing.id()) === index)
              .sort((a, b) => {
                return b.createdAt() - a.createdAt();
              })
              .map((post) => {
                return CommentPost.component({ post });
              })}
          </div>
        </div>
      </div>
    );
  }
}
